import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const ModalError = ({ show, setShow, title, messages, textButton, runSkip, skip, runCancel }) => {
  const handleCancel = () => {
    if (runCancel) runCancel();
    setShow(false);
  };

  return (
    <Modal size="md" show={show} onHide={handleCancel} backdrop="static">
      <Modal.Header closeButton>
        <strong className="text-danger">{title}</strong>
      </Modal.Header>

      <Modal.Body>
        {messages?.map((message, index) => (
          <div key={index}>{message}</div>
        ))}
      </Modal.Body>

      <Modal.Footer>
        {/* Cancel */}
        <Button variant="secondary" onClick={handleCancel}>
          {textButton}
        </Button>

        {/* Skip */}
        {skip && (
          <Button
            variant="primary"
            onClick={() => {
              if (runSkip) runSkip();
              setShow(false);
            }}
          >
            {skip}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalError;
